export default __webpack_public_path__ + "static/media/red-candy.dfce13f4.png";